import processClient from '.'
import { getAuthHeaders } from 'utils/requests'
import { cachedFetch } from 'utils/memoryCache'
import { CACHE_TTL } from 'utils/cacheTtl'

const findProcesses = async (
  paginate,
  searchNProcesso,
  responsible,
  startDate,
  state,
  processStatus,
  expireDate,
  searchPartePROPrincipalNome,
  searchParteCONPrincipalNome,
  processType,
  extraParams = {}
) => {
  const config = {
    headers: getAuthHeaders(),
    params: {},
  }
  
  if (paginate === null) {
    // null é o sinal explícito de "sem paginação" (exportação completa).
    // paginate === 0 é apenas a primeira página normal e não deve cair aqui,
    // senão toda tela que carrega a página 0 (ex.: Dashboard) passa a buscar
    // até 999999 processos de uma vez.
    config.params.paginate = 0
    config.params.limit = 999999
  } else if (paginate || paginate === 0) {
    config.params.paginate = paginate
  }

  if (searchNProcesso) {
    config.params.NProcesso = searchNProcesso
  }
  if (searchPartePROPrincipalNome) {
    config.params.PartePROPrincipalNome = searchPartePROPrincipalNome
  }
  if (searchParteCONPrincipalNome) {
    config.params.ParteCONPrincipalNome = searchParteCONPrincipalNome
  }
  if (responsible) {
    config.params.ResponsavelId = responsible
  }

  if (startDate && startDate.length === 2) {
    config.params.dataCadCausaStart = startDate[0]
    config.params.dataCadCausaLast = startDate[1]
  }

  if (expireDate) {
    config.params.DiasVencimento = expireDate
  }

  if (state) {
    config.params.UF = state
  }

  if (processStatus) {
    config.params.Status = processStatus
  }

  if (processType) {
    config.params.Phase = processType
  }

  // Filtros adicionais (ex.: { ResultadoAcao: 'ganho' }) — ignora vazios
  Object.entries(extraParams || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') config.params[key] = value
  })

  const cacheKey = `processes:find:${JSON.stringify(config.params)}`

  return cachedFetch(
    cacheKey,
    async () => processClient.get('/find', config),
    { ttlMs: CACHE_TTL.PROCESSES }
  )
}

export const listActiveProcesses = async () => {
  const config = {
    headers: getAuthHeaders(),
    params: {
      Status: 'ATIVO'
    }
  }

  return cachedFetch(
    'processes:active',
    async () => processClient.get('/find', config),
    { ttlMs: CACHE_TTL.PROCESSES }
  )
}

export default findProcesses
